export enum PaymentStatus {
  /** Payment object created locally; Stripe charge not yet initiated. */
  Pending = 'Pending',
  /** Customer action is required before the charge can proceed (e.g. 3DS authentication). */
  RequiresAction = 'RequiresAction',
  /** Stripe has confirmed the payment succeeded. Only set via webhook. */
  Succeeded = 'Succeeded',
  /** Payment attempt failed. */
  Failed = 'Failed',
  /** Payment was fully refunded after succeeding. */
  Refunded = 'Refunded',
  /** Payment was partially refunded after succeeding. */
  PartiallyRefunded = 'PartiallyRefunded',
  /** Payment intent was canceled before capture. */
  Canceled = 'Canceled',
}
